'use client';

import { Box } from '@chakra-ui/react';

import Header from '@/components/business/Header/Header';
import Sidebar from '@/components/business/Sidebar/Sidebar';
import { useAppSelector } from '@/store/hooks';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const { isMainOverflowAuto } = useAppSelector((state) => state.ui);

  const mainOverflowStyle = isMainOverflowAuto ? 'auto' : 'visible';

  return (
    <Box
      display="flex"
      height="100dvh"
    >
      <Sidebar />
      <Box width="100%">
        <Header />
        <Box height="calc(100dvh - var(--app-header-h))" overflow={mainOverflowStyle}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;